<template>
  <v-menu v-model="open" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <button v-bind="attrs" v-on="on" :aria-label="$t('common.actions.changeLanguage')"
        style="margin-top: 10px; font-size: 16px; color: gray;">
        <v-icon>mdi-translate</v-icon>
        {{ $t('label.language') }}
      </button>
    </template>

    <v-list dense>
      <v-list-item
        v-for="opt in langs"
        :key="opt.value"
        :disabled="opt.value === current"
        @click="setLang(opt.value)"
      >
        <v-list-item-title>{{ opt.label }}</v-list-item-title>
        <v-spacer />
        <v-icon v-if="opt.value === current">mdi-check</v-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { loadLanguageAsync } from '@/plugins/i18n'

export default {
  name: 'LanguageSwitcher',
  data: () => ({
    open: false,
    langs: [
      { label: 'Español',  value: 'es' },
      { label: 'English',  value: 'en' },
      { label: 'Français', value: 'fr' },
    ]
  }),
  computed: {
    current() {
      return this.$i18n.locale
    }
  },
  async created() {
    if (this.$vuetify && this.$vuetify.lang) {
      this.$vuetify.lang.current = this.$i18n.locale
    }
  },
  methods: {
    async setLang(lang) {
      try {
        await loadLanguageAsync(lang)              
        if (this.$vuetify && this.$vuetify.lang) {
          this.$vuetify.lang.current = lang       
        }
        this.open = false                       
        this.$emit('changed', lang)               
      } catch (e) {
        this.$swal({ icon:'error', text: this.$t('common.errors.languageLoadFailed') })
        console.error(e)
      }
    }
  }
}
</script>
